import React from 'react';

import { throttle } from '../../../../utilities/helperFunctions';

export default class ScrollEventStatusProvider extends React.PureComponent {
    constructor(props) {
        super(props);

        this.responsiveNavBarTopRowHeight = 48;
        this.topApplyButtonGroupRef = React.createRef();
        this.bottomApplyButtonGroupRef = React.createRef();
        this.throttleInterval = 100;
        this.throttledEventListener = throttle(
            this.handleEventListening,
            this.throttleInterval
        );

        this.state = {
            shouldShowStickyNav: false,
        };
    }

    componentDidMount() {
        this.attachEventListener();
    }

    componentWillUnmount() {
        this.detachEventListener();
    }

    attachEventListener = () => {
        window.addEventListener('scroll', this.throttledEventListener);
        window.addEventListener('resize', this.throttledEventListener);
    };

    detachEventListener = () => {
        window.removeEventListener('scroll', this.throttledEventListener);
        window.removeEventListener('resize', this.throttledEventListener);
    };

    handleEventListening = () => {
        if (this.topApplyButtonGroupRef.current) {
            this.handleDisplayStickyCompanyHeader(
                this.topApplyButtonGroupRef.current.offsetTop,
                this.bottomApplyButtonGroupRef.current.offsetTop,
                this.bottomApplyButtonGroupRef.current.offsetHeight
            );
        }
    };

    handleDisplayStickyCompanyHeader = (
        topElementOffsetTop,
        bottomElementOffsetTop,
        bottomElementOffsetHeight
    ) => {
        const isApplyButtonTopOutOfViewScreen =
            window.pageYOffset - this.responsiveNavBarTopRowHeight >=
                topElementOffsetTop &&
            window.innerHeight +
                window.pageYOffset -
                this.responsiveNavBarTopRowHeight -
                bottomElementOffsetHeight <=
                bottomElementOffsetTop;

        this.setState({ shouldShowStickyNav: isApplyButtonTopOutOfViewScreen });
    };

    render() {
        const { children } = this.props;
        const { shouldShowStickyNav } = this.state;

        const newProps = {
            topApplyButtonGroupRef: this.topApplyButtonGroupRef,
            bottomApplyButtonGroupRef: this.bottomApplyButtonGroupRef,
            shouldShowStickyNav,
        };

        return typeof children === 'function'
            ? children({ ...newProps })
            : React.Children.map(children, (child) =>
                  React.cloneElement(child, { ...newProps })
              );
    }
}
